import React, { useState, useEffect } from "react";

export default function SingleColorPicker({ onSubmit, onCancel, initialValue }) {
  const [name, setName] = useState("");
  const [code, setCode] = useState("#000000");
  const [error, setError] = useState("");

  // Pre-fill when editing
  useEffect(() => {
    if (initialValue) {
      setName(initialValue.name || "");
      setCode(initialValue.code || "#000000");
    }
  }, [initialValue]);

  const handleSubmit = () => {
    if (!name.trim()) {
      setError("Color name is required");
      return;
    }
    if (!code) {
      setError("Please pick a color");
      return;
    }
    setError("");
    onSubmit({ name: name.trim(), code });
  };

  return (
    <div className="single-color-picker">

      {/* ── Color Name (manual text input) ── */}
      <div className="mb-3">
        <label className="form-label fw-semibold">
          Color Name <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="e.g. Sky Blue, Maroon, Olive Green"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            setError("");
          }}
        />
      </div>

      {/* ── Color Code (color picker) ── */}
      <div className="mb-3">
        <label className="form-label fw-semibold">
          Color Code <span className="text-danger">*</span>
        </label>

        <div className="d-flex align-items-center gap-3">
          {/* Native color wheel */}
          <input
            type="color"
            className="color-wheel-input"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            style={{
              width: 54,
              height: 54,
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              padding: 2,
              background: "transparent",
            }}
          />

          {/* Hex text input */}
          <input
            type="text"
            className="form-control"
            placeholder="#000000"
            value={code}
            maxLength={7}
            onChange={(e) => {
              const val = e.target.value;
              setCode(val);
            }}
            style={{ fontFamily: "monospace", letterSpacing: 1 }}
          />

      
        </div>

        <small className="text-muted">
          Click the color wheel or type a hex code like <code>#FF5733</code>
        </small>
      </div>

      {/* ── Error ── */}
      {error && (
        <div className="alert alert-danger py-2 mb-3">{error}</div>
      )}

      {/* ── Actions ── */}
      <div className="d-flex justify-content-end gap-2 mt-3">
        <button className="btn cuscancel" type="button" onClick={onCancel}>
          Cancel
        </button>
        <button className="btn cusBTNPop" type="button" onClick={handleSubmit}>
          {initialValue ? "Update Color" : "Add Color"}
        </button>
      </div>
    </div>
  );
}